import { bodyPart } from '../../../../constants/bodyPart';
import { gameImportType } from '../../../../constants/gameImportType';
import { actorType } from '../../../../constants/actorType';
import { Config as movementConfig } from './objectData/movementConfig';

export const wheelchairWomanAssetConfig = {
  NAME: 'WHEELCHAIRWOMAN',
  ACTORTYPE: actorType.OBJECT,
  DATA: [movementConfig],
  TYPE: gameImportType.SPRITESHEET,
  SPRITESHEET_FOLDER: 'wheelchair-woman',
  SPRITESHEET_NAME: 'Woman-Wheelchair-Sprite-Map-',
  CHATBUBBLECOORDINATES: { x: -0.4, y: -0.1 },
  INVENTORY: {
    [bodyPart.MOUTH]: [],
    [bodyPart.NECK]: [],
  },
  AUDIO: {},
  SCALE: 1.0,
  HEIGHT: 800,
  WIDTH: 800,
};
